export default "__VITE_ASSET__Fu18pOzA__"